import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Box, Select, MenuItem } from "@mui/material";
import { t } from "i18next";

import { translation, formatMessageEdit } from "utils";
import { ButtonComp } from "components";
import {
  getBadgeSwitchVideos,
  getFontFamily,
  getSelectedBadgeVideoId,
  getVisibleInPersonTour,
  getVisibleLiveVideoTour,
  getVisibleScheduleTour,
  getVisibleSelfGuidedTour,
  setIsVideoTourScreen,
  setSelectedVideoSwitchId,
} from "slices";
import { getIsMaximized } from "slices/window-slice/index";
import { setShouldFetchSlots } from "slices/param-slice/index";
import { resetScheduleTourState } from "slices/schedule-tour-slice/index";

const TopBar = () => {
  const dispatch = useDispatch();
  const isMaximized = useSelector(getIsMaximized);
  const items = useSelector(getBadgeSwitchVideos);
  const selectedId = useSelector(getSelectedBadgeVideoId);
  const fontFamily = useSelector(getFontFamily);
  const visibleScheduleTour = useSelector(getVisibleScheduleTour);
  const visibleInPersonTour = useSelector(getVisibleInPersonTour);
  const visibleLiveVideoTour = useSelector(getVisibleLiveVideoTour);
  const visibleSelfGuidedTour = useSelector(getVisibleSelfGuidedTour);

  const onBadgeClick = (item) => {
    dispatch(setSelectedVideoSwitchId(item));

    const eventHash = {
      event_name: "h_click",
      event_params: {
        h_page_type: "hayley",
        h_display_method: "iframe",
        h_clicked_location: "videos",
        h_click_value: item,
      },
    };

    window.parent.postMessage(JSON.stringify(eventHash), "*");
  };

  const startScheduleTour = () => {
    // Clear cached tour data and force refetch
    dispatch(resetScheduleTourState());
    dispatch(setShouldFetchSlots(true));
    formatMessageEdit("ScheduleTour", "scheduleTour", "videos");
    dispatch(setIsVideoTourScreen(false));
  };

  return (
    <Box
      className={`hayley-custom hayley-flex ${isMaximized ? "hayley-p-2" : ""} hayley-flex-wrap hayley-items-center hayley-justify-between`}
      sx={{ "&.hayley-custom": { fontFamily: `${fontFamily} !important` } }}
    >
      <div className="hayley-hidden hayley-max-w-fit hayley-flex-wrap hayley-items-center sm:hayley-flex">
        {items.map((item) => (
          <Button
            key={item.id}
            onClick={() => onBadgeClick(item?.id)}
            className={`hayley-custom  hayley-mr-[6px] hayley-box-border hayley-rounded-sm hayley-border hayley-border-solid hayley-px-4 hayley-py-2 hayley-text-base hayley-font-semibold hayley-capitalize hayley-leading-5 hayley-tracking-tight ${
              selectedId === item.id
                ? "hayley-border-custom-8 hayley-bg-custom-8 hayley-text-white"
                : "hayley-border-custom-7 hayley-bg-custom-7 hayley-text-secondary hover:hayley-border-custom-13 hover:hayley-bg-custom-13"
            } disabled:hayley-cursor-not-allowed`}
            sx={{ "&.hayley-custom": { fontFamily: `${fontFamily} !important` } }}
          >
            {translation(item.id, item.title)}
          </Button>
        ))}
      </div>
      <div className="sm:hayley-hidden">
        <Select
          value={selectedId}
          onChange={(e) => onBadgeClick(e.target.value)}
          displayEmpty
          className="!hayley-h-10 !hayley-w-[140px]"
          inputProps={{ "aria-label": "Without label" }}
        >
          {items.map((item) => (
            <MenuItem value={item.id}>{translation(item.id, item.title)}</MenuItem>
          ))}
        </Select>
      </div>
      {visibleScheduleTour && (visibleInPersonTour || visibleLiveVideoTour || visibleSelfGuidedTour) && (
        <ButtonComp label={t("scheduleTour")} onClick={startScheduleTour} disabled={false} filled={true} />
      )}
    </Box>
  );
};

export default TopBar;
